module.exports = __webpack_public_path__ + "static/media/VA_map@2x.026bb589.png";